import { type GCSConnectionCredentials } from "common";
import { createContext, type JSX, type ReactNode, useState } from "react";

interface Props {
  children?: ReactNode;
}

export interface IGoogleCloudConnectionContext {
  connectionCredentials: GCSConnectionCredentials | null;
  setConnectionCredentials: (newState: GCSConnectionCredentials) => void;
}

const initial = {
  connectionCredentials: null,
  setConnectionCredentials: (): void => {},
};

const GoogleCloudConnectionContext =
  createContext<IGoogleCloudConnectionContext>(initial);

const GoogleCloudConnectionProvider = ({ children }: Props): JSX.Element => {
  const [connectionCredentials, setConnectionCredentials] =
    useState<GCSConnectionCredentials | null>(null);

  return (
    <GoogleCloudConnectionContext.Provider
      value={{ connectionCredentials, setConnectionCredentials }}>
      {children}
    </GoogleCloudConnectionContext.Provider>
  );
};

export { GoogleCloudConnectionContext, GoogleCloudConnectionProvider };
